import { PropsWithChildren } from "react";
import { Stack } from "../../../stack";
import { MessageDirection } from "@edgetier/watchtower-types";

/**
 * A layout wrapper that aligns child messages to the left (inbound) or right (outbound) side.
 * @param {MessageDirection} props.direction - The message direction determining alignment.
 * @param {React.ReactNode} props.children - The message components to render within the list.
 * @returns {JSX.Element} The MessagesList component.
 */
const MessagesList = ({ direction, children }: PropsWithChildren<{ direction: MessageDirection }>) => {
    return (
        <Stack align={direction === MessageDirection.Outbound ? "flex-end" : "flex-start"} w="100%">
            {children}
        </Stack>
    );
};

export { MessagesList };
